import { render, staticRenderFns } from "./ListWithIcons.vue?vue&type=template&id=67197dde&scoped=true"
import script from "./ListWithIcons.vue?vue&type=script&lang=js"
export * from "./ListWithIcons.vue?vue&type=script&lang=js"
import style0 from "./ListWithIcons.vue?vue&type=style&index=0&id=67197dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67197dde",
  null
  
)

export default component.exports